import { useAppConfigContext } from "@/context/AppConfig";
import { useReportRedirect } from "@/reports/useReportRedirect/useReportRedirect";
import { Text } from "@/theme/index";
import type { ValidReportTypes } from "@/utils/helperTypes";
import { useEffect, useState } from "react";
import { ReportActions, ReportCard } from "..";

export interface RecentReportsItemProps {
  reportTitle: string;
  detailsCityState?: string;
  reportPermaLink: string;
  reportType: ValidReportTypes;
  createdDate: string;
  updatedDate: string;
  reportTypeButton?: string;
  age?: string;
  deleteCurrentReport: (permalink: string) => void;
}

export function RecentReportsCard({
  reportPermaLink,
  reportTitle,
  detailsCityState,
  age,
  reportType,
  createdDate,
  updatedDate,
  reportTypeButton,
  deleteCurrentReport,
}: RecentReportsItemProps) {
  const { redirectToReportUrl } = useReportRedirect();
  const { trackEventGA4 } = useAppConfigContext();
  const [shouldSwitchTitleAndSubtitle, setShouldSwitchTitleAndSubtitle] =
    useState<boolean>(false);
  const [subtitle, setSubtitle] = useState<string | undefined>(undefined);
  const [isVehicleReport, setIsVehicleReport] = useState<boolean>(false);
  const [shouldSeeReportTypeText, setShouldSeeReportTypeText] =
    useState<boolean>(false);

  function onReportRedirectClick() {
    trackEventGA4({
      event_name: "recent_report_card_click",
      report_type: reportType,
    });
    redirectToReportUrl(
      reportType.toLocaleLowerCase() as ValidReportTypes,
      reportPermaLink,
    );
  }

  useEffect(() => {
    setIsVehicleReport(reportType.toLowerCase() === "vehicle");
  }, [reportType]);

  useEffect(() => {
    setShouldSwitchTitleAndSubtitle(true);
  }, []);

  useEffect(() => {
    if (
      reportType.toLowerCase() === "vehicle" &&
      shouldSwitchTitleAndSubtitle &&
      !!detailsCityState
    ) {
      setSubtitle(reportTitle);
    } else if (reportType.toLowerCase() === "person") {
      const subTitle = age
        ? `Age: ${age}, ${detailsCityState}`
        : detailsCityState;
      setSubtitle(subTitle);
    }
  }, [
    shouldSwitchTitleAndSubtitle,
    reportType,
    reportTitle,
    detailsCityState,
    age,
  ]);

  useEffect(() => {
    setShouldSeeReportTypeText(
      isVehicleReport && shouldSwitchTitleAndSubtitle
        ? false
        : !reportTypeButton,
    );
  }, [isVehicleReport, shouldSwitchTitleAndSubtitle, reportTypeButton]);
  return (
    <>
      <ReportCard
        title={reportTitle}
        reportType={reportType}
        clickAction={onReportRedirectClick}
        description={
          <>
            {subtitle && (
              <Text
                data-cy="recent_reports_card_subtitle"
                color="success.main"
                mb={1}
                lineHeight={"24px"}
              >
                {subtitle}
              </Text>
            )}
            {shouldSeeReportTypeText && (
              <Text lineHeight={"16px"} mb={1}>
                {reportType} Report
              </Text>
            )}
            <Text lineHeight={"16px"} mb={1}>
              {" "}
              {`Updated ${updatedDate} | Created ${createdDate}`}{" "}
            </Text>
            <ReportActions
              reportTitle={reportTitle}
              reportType={reportType}
              reportPermaLink={reportPermaLink}
              deleteCurrentReport={deleteCurrentReport}
            />
          </>
        }
      />
    </>
  );
}
